import {CardText} from "material-ui/Card"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import TextField from "material-ui/TextField"
import Button from "material-ui/RaisedButton"
import React from "react"
import {Redirect} from "react-router-dom"
import * as Util from "../common"
import {containers} from "@swarm2/core"
import SubmitIcon from "material-ui/svg-icons/communication/vpn-key"
import _Error from "../auth-signin/Error"

const M = Util.intlMessages("view.BetaKeyApplyView")
const EM = Util.intlMessages("view.BetaKeyApplyView.error")
const Error = _Error(EM)

function BetaKeyApplyRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    isSubmitAllowed,
    onSubmit,
    formErrors,
    request,
    userId,
    betaKey,
  } = props
  if (request.status === "success") {
    return <Redirect to="/auth/register" />
  }
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <p>
          <M
            id="description"
            values={{
              userId: <code>{userId}</code>,
              betaKey: <code>{betaKey}</code>,
            }}
          />
        </p>
        <div>
          <TextField
            name="errors"
            underlineShow={false}
            disabled={true}
            errorText={
              request.status === "pending"
                ? null
                : formErrors.map(
                    (error, i) =>
                      // quick hack - redirect to success when done
                      error === "alreadyaccess" ? (
                        <Redirect key={i} to="/auth/register" />
                      ) : (
                        <div key={i}>
                          <Error error={error} />
                        </div>
                      ),
                  )
            }
          />
        </div>
        <div>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!isSubmitAllowed}
            onClick={onSubmit}
          />
        </div>
        {request.status === "pending" ? (
          <div>
            <Util.LoadingSpinner />
          </div>
        ) : null}
      </CardText>
    </div>
  )
}
export default containers.beta.BetaKeyApply(BetaKeyApplyRender)



// WEBPACK FOOTER //
// ./src/beta/BetaKeyApplyView.js